import { c as _c } from "react/compiler-runtime";
import type { Country } from "@website/ticket-ui/visa/types";
import { CounterButton } from "@website/ui/counter-button";
import { ListItem } from "@website/ui/list-item";
import { MiniPopover, MiniPopoverPropertiesType } from "@website/ui/mini-popover";
type AdultAndChild = {
  adult: number;
  child: number;
};
type PersonValue = {
  person: number;
};
type PeoplePopoverType = {
  value: AdultAndChild | PersonValue;
  type: Country["form"]["personType"];
  onChange: (v: number, name: "adult" | "child" | "person") => void;
};
export type PeoplePopoverProperties = MiniPopoverPropertiesType & PeoplePopoverType;
type PeopleValueFieldsProperties<TValue> = {
  onChange: PeoplePopoverType["onChange"];
  value: TValue;
};
const ChildAndAdult = t0 => {
  const $ = _c(15);
  const {
    onChange,
    value
  } = t0;
  const t1 = value.adult <= 1;
  let t2;
  if ($[0] !== onChange) {
    t2 = n => {
      onChange(n, "adult");
    };
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== value.adult) {
    t3 = <ListItem EndAction={<CounterButton aria-label={"\u0628\u0632\u0631\u06AF\u0633\u0627\u0644"} color="secondary" decreaseDisabled={t1} locale="fa" onChange={t2} value={value.adult} variant="outline" />} subtitle={"\u06F1\u06F8 \u0633\u0627\u0644 \u0628\u0647 \u0628\u0627\u0644\u0627"} title={"\u062A\u0639\u062F\u0627\u062F \u0628\u0632\u0631\u06AF\u0633\u0627\u0644"} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = value.adult;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = value.child <= 0;
  let t5;
  if ($[6] !== onChange) {
    t5 = n_0 => {
      onChange(n_0, "child");
    };
    $[6] = onChange;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== value.child) {
    t6 = <ListItem EndAction={<CounterButton aria-label={"\u06A9\u0648\u062F\u06A9"} color="secondary" decreaseDisabled={t4} locale="fa" onChange={t5} value={value.child} variant="outline" />} subtitle={"\u062A\u0639\u062F\u0627\u062F \u06A9\u0648\u062F\u06A9"} title={"\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06F1\u06F8 \u0633\u0627\u0644"} />;
    $[8] = t4;
    $[9] = t5;
    $[10] = value.child;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
const Person = t0 => {
  const $ = _c(6);
  const {
    onChange,
    value
  } = t0;
  const t1 = value.person <= 1;
  let t2;
  if ($[0] !== onChange) {
    t2 = n => {
      onChange(n, "person");
    };
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== value.person) {
    t3 = <ListItem EndAction={<CounterButton aria-label={"\u062A\u0639\u062F\u0627\u062F \u0646\u0641\u0631\u0627\u062A"} color="secondary" decreaseDisabled={t1} locale="fa" onChange={t2} value={value.person} variant="outline" />} title={"\u062A\u0639\u062F\u0627\u062F \u0646\u0641\u0631\u0627\u062A"} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = value.person;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const PeoplePopover = properties => {
  const $ = _c(17);
  const {
    value: propertyValue,
    onChange,
    type,
    onClose
  } = properties;
  let t0;
  if ($[0] !== onChange || $[1] !== propertyValue || $[2] !== type) {
    t0 = type === "childAndAdult" && <ChildAndAdult onChange={onChange} value={propertyValue as AdultAndChild} />;
    $[0] = onChange;
    $[1] = propertyValue;
    $[2] = type;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== onChange || $[5] !== propertyValue || $[6] !== type) {
    t1 = type === "person" && <Person onChange={onChange} value={propertyValue as PersonValue} />;
    $[4] = onChange;
    $[5] = propertyValue;
    $[6] = type;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== onClose) {
    t2 = <div className="border-t px-6 pb-6 pt-4"><button className="button lg contained secondary w-full" onClick={onClose}>تایید</button></div>;
    $[8] = onClose;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2) {
    t3 = <div className="w-full">{t0}{t1}{t2}</div>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== properties || $[15] !== t3) {
    t4 = <MiniPopover {...properties} title={"\u062A\u0639\u062F\u0627\u062F \u0646\u0641\u0631\u0627\u062A"}>{t3}</MiniPopover>;
    $[14] = properties;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};